import PropTypes from 'prop-types';
import CustomTab from '../CustomTab';

/**
 * ProtectedTab Component
 * 
 * A tab that only renders if user has permission to access it.
 */
const ProtectedTab = ({
  component,
  tabName,
  label,
  tabDisabled=false,
  requiredRoles,
  accessibleTabs,
  ...tabProps
}) => {
  if (!accessibleTabs.includes(tabName)) {
    return null;
  }

  return <CustomTab {...tabProps} label={label} disabled={tabDisabled} />;
};

ProtectedTab.propTypes = {
  component: PropTypes.string,
  tabName: PropTypes.string,
  requiredRoles: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string.isRequired,
};

export default ProtectedTab;